import type { Attachment } from '../types/attachment';

const STATUS_COMPLETE = 'complete';

export default (
  attachmentMetadataStatus: Attachment['attachmentMetadataStatus'],
  isAttachmentExpired: Attachment['isAttachmentExpired'],
) => {
  return attachmentMetadataStatus !== STATUS_COMPLETE && !isAttachmentExpired;
};
